import { get, post } from '@/api/request.js'
import { requestData } from '@/common/js/commont.js'

// 获取设备列表
export const getAreaList = data => post('/api/area/getAreaList', requestData(data))

// 获取设备数据列表
export const getDeviceLogList = data => post('/api/device/getDeviceLogList', requestData(data))

// 获取设备类型
export const getDeviceType = data => post('/api/device/getDeviceType', requestData(data))
